export const getDefaultTabProp = () => {
  return {
    tabIndicatorProps: {
      style: {
        height: '5px',
        borderRadius: '1em',
        backgroundColor: "rgb(112, 124, 168)"
      },
    },
    sx: {
      "& button": {
        "&:hover": {
          backgroundColor: "transparent",
          color: '#373737'
        },
      },
      "& .MuiButtonBase-root": {
        fontSize: "16px",
        color: '#aaaaaa',
        "&:hover": {
          color: '#aaaaaa'
        },
        "&.Mui-selected": {
          fontWeight: 600,
          color: "rgb(112, 124, 168)",
        },
      },
    },
  };
}

export const getDefaultDividerProp = () => {
  return {
    style: {
      width: '1px', height: '40px', margin: '0 20px',
      backgroundColor: '#E0E0E0',
    }
  };
}

export const getDefaultSearchBoxProp = () => {
  return {
    sx: {
      display: "flex", padding: "3px 10px 3px", marginRight: '5px',
    },
    textField: {
      sx: {
        "& .MuiOutlinedInput-root": {
          borderRadius: "50px",
          width: "200px",
          height: "33px",
          bgcolor: "#eeeeee",
        },
        "& .MuiOutlinedInput-input": {
          color: "black",
          fontSize: '13px'
        },
        "& .MuiOutlinedInput-input:focus": {
          backgroundColor: 'transparent',
        }
      }
    }
  };
}

export const getDefaultTableProp = (rowIndex) => {
  return {
    tableHead: {
      sx: {
        "& th": {
          color: "#aaaaaa",
          fontSize: "15px",
          fontWeight: "500",
        },
        borderTop: "none",
        borderColor: "1px solid #d5d5d5",
      },
      tableRow: {
        sx: {
          backgroundColor: "#ffffff"
        },
      },
      tableCell: {
        text: {
          textTransform: "none",
          "&:not(:last-of-type)::after": {
            display: "none",
          },
        },
        checkbox: {
          "&:not(:last-of-type)::after": {
            display: "none",
          },
        }
      }
    },
    tableBody: {
      tableRow: {
        cursor: "pointer",
        backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#f6f6f6',
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      },
      tableCell: {
        textTransform: "none",
        "&:not(:last-of-type)::after": {
          display: "none",
        },
      },
      checkbox: {
        "&:not(:last-of-type)::after": {
          display: "none",
        },
      },
    },

  };
}

export const getDefaultTextFieldProp = () => {
  return {
    inputProps: { fontSize: '13px' },
    sx: {
      "& .MuiOutlinedInput-root": {
        width: "98%",
        height: "32px",
        borderRadius: "8px",
        fontSize: '13px'
      },
      "& .MuiOutlinedInput-input:focus": {
        backgroundColor: 'transparent',
      }
    },
  };
}

export const getDefaultSelectProp = () => {
  return {
    style: {
      backgroundColor: 'white',
      width: '110px',
      height: '32px',
      fontWeight: 'bold',
    },
    sx: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '8px',
      },
      "& .MuiInputBase-input": {
        fontSize: "13px",
      },
    },
    menuProps: {
      sx: {
        "&& .Mui-selected": {
          backgroundColor: "white",
        },
        "&& .MuiMenuItem-root": {
          color: "#737791",
          fontSize: "13px",
          height: "40px",
          margin: "0 10px",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#dbe0fc"
          },
        },
      },
    },
  }
}

export const getDefaultCheckboxProp = () => {
  return {
    sx: {
      "&:hover": { backgroundColor: "transparent" },
    }
  };
}

export const getDefaultMenuItemSx = () => ({
  height: "30px",
  fontSize: "14px",
  color: "#707cab",
  padding: "8px 16px",
  borderRadius: 1,
  "&:hover": {
    color: "#8695CB",
    bgcolor: "#dbe0fc",
    borderRadius: 1,
  },
});